<template>
  <div>
    <q-dialog :visible="isVisible" title="退款日志" width="750px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <el-table stripe v-loading="loading" border highlight-current-row :data="tableData" :height="400">
        <el-table-column prop="roleType" label="操作角色" align="center" width="90"></el-table-column>
        <el-table-column prop="name" label="角色名称" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="operateContent" label="操作内容" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="createdTime" label="操作时间" align="center" width="180" show-overflow-tooltip></el-table-column>
      </el-table>
      <div style="text-align: center; margin-top: 20px">
        <el-button @click="onCancel" size="medium">关 闭</el-button>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    id: [String,Number]
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        if (this.visible) {
          this.refundDetail()
        }
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    };
  },
  methods: {
   refundDetail() {
      this.loading = true
      this.$api.dataReport.findRefundLog(this.id)
        .then(res => {
          if (res.success) {
            this.tableData = res.data
          }
        }).finally(_=> {
          this.loading = false
        })
    },
    onCancel() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
</style>
